import { render, staticRenderFns } from "./SqlVariableMappingTable.vue?vue&type=template&id=b8ab1814"
import script from "./SqlVariableMappingTable.vue?vue&type=script&lang=js"
export * from "./SqlVariableMappingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports